import { dashboardUrl, ILeftNavBarArray } from "../utils/constants";
import { IUserObj } from "../types/genericTypes";
import { leftNavBarArray } from "../utils/constants";
import {
  CkycAddressFormat,
  IAddressFormat,
} from "../Profile/AddressField/AddressField";
import {
  ckycAddressObj,
  initialAddressObj,
} from "../Profile/ProfileForm/ProfileForm";

interface IPersonaldetails {
  firstname?: string;
  lastname?: string;
  middlename?: string;
  mobile?: string;
  emailId?: string;
  aadhaar?: string;
  pan: string;
  panDetails?: string;
  gender?: "M" | "F" | string;
  dob?: string;
  additionalemail?: string;
  additionalmobile?: string;
  PANName?: string;
  adrLine1?: string;
  adrLine2?: string;
  city?: string;
  state?: string;
  pincode?: string;
}

interface IStageStatus {
  isregistrationcompleted?: boolean;
  ispersonaldetailscompleted: boolean;
  isprofiledetailscompleted: boolean;
  isnewdpnomineecompleted?: boolean;
  isnewdpguardiancompleted?: boolean;
  isbankdetailscompleted: boolean;
  isbrokeragesegmentcompleted?: boolean;
  isuploaddocumentscompleted: boolean;
  isipvarificationcompleted?: boolean;
  isbrokerageschemecompleted?: boolean;
  isagentvisitcompleted?: boolean;
  isesigncompleted: boolean;
  isdigilockercompleted?: boolean;
  isaddressstagecompleted: boolean;
  bpm_pd_status: number;
  bpm_nsb_status: number;
  applicationstatus: number;
  iskra: boolean;
  iskyc: boolean;
  ckycnumber: string;
  iskraesigncompleted: boolean;
  ispanlinkedwithaadhar: boolean;
  checkpanaaddharflag: boolean;
  dpaccounttype: any;
  dpaccountchanged: boolean;
  dob: string;
  isPCGSubLob: boolean;
  panfirstname?: string;
  panmiddletname?: string;
  panlastname?: string;
  dp_account_type?: number;
  accounttype?: number;
  accountcategory?: number;
  isdpcompleted?: boolean;
  first_esign_initiated?: boolean;
  second_esign_req?: boolean;
  second_esign_initiated?: boolean;
  rmassisted?: boolean;
  first_esign_revoke?: boolean;
  second_esign_revoke?: boolean;
}

export default class GlobalStore {
  static user: IUserObj = {
    firstname: "",
    lastName: "",
    email: "",
    mobile: "",
    countryCode: "+91",
    city: "",
    rmCode: "",
    UCC_Code: "",
    accountType: "",
    userId: "",
    middleName: "",
  };
  static isPartialFilledClient: boolean = false;
  static leadForDsa: boolean = false;
  static SaveKYCResponse: any = {};
  static personaldetails: any = {};
  static profileDetails: any = {};
  static LeadIdMsg: string;
  static createLeadDudupeParam: any = {};
  static leadId: string;
  static sessionId: string;
  static dateofbirth: string = "";
  static dob: string = "";
  static birthDate: string = "";
  static applicationID: string = "";
  static aadharLinkedChoice: boolean = false;
  static clientPrimaryDetailId: string = "";
  static pennyDropCount: string = "";
  static clientStageStatus: any = {};
  static dashboardDefaultUrl = dashboardUrl.profile;
  static dashboardActivetUrl = dashboardUrl.profile;
  static leftNavBarState: Array<ILeftNavBarArray> = [...leftNavBarArray];
  static dpid: string = "";
  static clientid: string = "";
  static dateOfIncorporation: string = "";
  static nonIndFullName: any = "";
  static stageStatus: IStageStatus = {
    isregistrationcompleted: false,
    ispersonaldetailscompleted: false,
    isprofiledetailscompleted: false,
    isnewdpnomineecompleted: false,
    isnewdpguardiancompleted: false,
    isbankdetailscompleted: false,
    isbrokeragesegmentcompleted: false,
    isuploaddocumentscompleted: false,
    isipvarificationcompleted: false,
    isbrokerageschemecompleted: false,
    isagentvisitcompleted: false,
    isesigncompleted: false,
    isdigilockercompleted: false,
    isaddressstagecompleted: false,
    bpm_pd_status: 0,
    bpm_nsb_status: 0,
    applicationstatus: 0,
    iskra: false,
    iskyc: false,
    ckycnumber: "",
    iskraesigncompleted: false,
    ispanlinkedwithaadhar: false,
    checkpanaaddharflag: false,
    dpaccounttype: "",
    dpaccountchanged: false,
    dob: "",
    isPCGSubLob: false,
    isdpcompleted: false,
    first_esign_initiated: false,
    second_esign_req: false,
    rmassisted: false,
    first_esign_revoke: false,
    second_esign_revoke: false
  };
  static accountcategory: number;
  static isDigiLocker: boolean = false;
  static isKRA: boolean = false;
  static isKYC: boolean = false;
  static isManual: boolean = false;
  static isNormalClient: boolean = false;
  static isPANVerified: boolean = false;
  static isSeniorCitizen: boolean = false;
  static panOCRObj: any = {};
  static chequeOCRObj: any = {};
  static aadhaarOCRObj: any = {};
  static passportOCRObj: any = {};
  static dlOCRObj: any = {};
  static voterIdOCRObj: any = {};
  static corrAadhaarOCRObj: any = {};
  static corrPassportOCRObj: any = {};
  static corrDlOCRObj: any = {};
  static corrVoterIdOCRObj: any = {};
  static accountHolderName: string = "";
  static isSeeding: boolean = false;
  static selfieUrl: string = "";
  static nextIncompleteStage: string = "";
  static kraInfoObject: CkycAddressFormat = { ...ckycAddressObj };
  static ckycInfoObject: CkycAddressFormat = { ...ckycAddressObj };
  static ckycNo: string = "";
  static token: string = "";
  static account_no: string = "";
  static ifsc_code: string = "";
  static location: any = "";
  static KRA_mobile?: string;
  static KRA_email?: string;
  static KRA_mode?: number;
  static addressLine1?: string;
  static sameAsPermanent?: boolean;
  static corrAddress?: string;
  static PinCode?: string;
  static corrPincode?: string;
  static fieldErrorBank: Array<any> = [
    // errCode1: "test errror",
  ];
  static entityType?: any;
  static entitySubType?: any;
  static externalDetails?: any;
  static isOTCFlow?: any = false;
  static IsDigiLockerDirectFlow?: any = false;
  static isNriOtc?: any = false;
  static isNriInv?: any = false;

  /**
   * The ONLY function allowed to update `GlobalStore.leftNavBarState`.
   * Every part of the codebase that needs to add/remove/replace/mutate the
   * left navigation bar state MUST go through this method instead of
   * assigning to `GlobalStore.leftNavBarState` directly.
   *
   * Accepts either:
   *  - a full replacement array (mirrors the previous "direct assignment" usages), or
   *  - an updater function that receives the current state and returns the
   *    next state (mirrors the previous "push/splice/mutate" usages), so
   *    existing callers can keep their exact logic without extra boilerplate.
   */
  static setLeftNavBarState(
    nextState:
      | Array<ILeftNavBarArray>
      | ((prevState: Array<ILeftNavBarArray>) => Array<ILeftNavBarArray>)
  ): Array<ILeftNavBarArray> {
    GlobalStore.leftNavBarState =
      typeof nextState === "function"
        ? (
            nextState as (
              prevState: Array<ILeftNavBarArray>
            ) => Array<ILeftNavBarArray>
          )(GlobalStore.leftNavBarState)
        : nextState;
    return GlobalStore.leftNavBarState;
  }
}
